import { combineReducers } from "redux";

function EsperDeviceReducer() {
  const esperDevicesInitialState = {
    error: null,
    loading: false,
    devices: null,
  };

  const esperDevicesLatestEventInitialState = {
    error: null,
    loading: false,
    devicesLatestEvents: null,
  };

  const esperDevice = (state = esperDevicesInitialState, action) => {
    const { type, payload } = action;

    switch (type) {
      case "GET_DEVICES_INIT":
        return {
          ...state,
          loading: true,
          error: null,
          devices: null,
        };
      case "GET_DEVICES_SUCCESS":
        return {
          ...state,
          loading: false,
          error: null,
          devices: payload,
        };
      case "GET_DEVICES_ERROR":
        return {
          ...state,
          loading: false,
          error: payload,
          devices: null,
        };
      default:
        return state;
    }
  };

  const esperDevicesLatestEvent = (
    state = esperDevicesLatestEventInitialState,
    action,
  ) => {
    const { type, payload } = action;

    switch (type) {
      case "GET_DEVICES_LATEST_EVENTS_INIT":
        return {
          ...state,
          loading: true,
          error: null,
          devicesLatestEvents: null,
        };
      case "GET_DEVICES_LATEST_EVENTS_SUCCESS":
        return {
          ...state,
          loading: false,
          error: null,
          rebootWristband: payload,
        };
      case "GET_DEVICES_LATEST_EVENTS_ERROR":
        return {
          ...state,
          loading: false,
          error: payload,
          rebootWristband: null,
        };
      default:
        return state;
    }
  };

  return combineReducers({
    esperDevice,
    esperDevicesLatestEvent,
  });
}

export default EsperDeviceReducer();
